/* eslint-disable no-unused-vars */
export enum deviceOs {
  windowsPhone = 'Windows Phone',
  android = 'Android',
  ios = 'iOS',
}
